import { createContext, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ODSLoadingSpinner } from '@telekom-ods/react-ui-kit';

const GlobalLoaderContext = createContext();

const GlobalLoaderProvider = ({ children }) => {
  const reduxLoading = useSelector((state) => state.status.loading);
  const [activeContextLoaders, setActiveContextLoaders] = useState(0);
  const [globalLoaderEnabled, setGlobalLoaderEnabled] = useState(true);
  const contextLoading = activeContextLoaders > 0;
  const loading = reduxLoading || contextLoading;
  const contextValue = useMemo(
    () => ({
      loading,
      startContextLoading: () => setActiveContextLoaders((prev) => prev + 1),
      stopContextLoading: () => setActiveContextLoaders((prev) => Math.max(prev - 1, 0)),
      setGlobalLoaderEnabled,
    }),
    [loading, globalLoaderEnabled],
  );

  return (
    <GlobalLoaderContext.Provider
      value={contextValue}
    >
      {globalLoaderEnabled && (
        <div
          style={{
            position: 'fixed',
            display: loading ? 'flex' : 'none',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(221, 221, 221, 0.47)',
            height: '100vh',
            width: '100vw',
            zIndex: 1000,
          }}
        >
          <ODSLoadingSpinner size="large" />
        </div>

      )}
      {children}
    </GlobalLoaderContext.Provider>
  );
};

export { GlobalLoaderContext, GlobalLoaderProvider };

GlobalLoaderProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
